import React, { Component } from 'react';
// import './invite-user.scss';
import Avatar from '../../components/avatar';
import PropTypes from 'prop-types';
import {
  Row,
  Col
} from 'react-bootstrap';
import '../invite-user.scss';
export class InviteTenantUser extends Component {
  static propTypes = {
    onBack: PropTypes.func,
    isHidden: PropTypes.bool,
    userProfile: PropTypes.object
  }

  constructor(props) {
    super(props);
  }

  render() {
    return (!this.props.isHidden) &&
      <div className={this.props.isHidden ? 'cls-hidden' : ''}>
        <div className='box-form-body'>
          <Row>
            <Col md={6} sm={6}>
              <p className='description'>
            The email address <span className='cls-bold'>{this.props.userProfile.email}</span>  already belongs to this SiteOne Services staff:
              </p>
              <div className='form-group'>
                <div className='cls-existing-user'>
                  <Avatar src={null} size={80} />
                  <h4 className='cls-bold margin-top-0'>{this.props.userProfile.fullName}</h4>
                  <p>{this.props.userProfile.email}</p>
                  <div className='user-details'>
                    <span className='col-md-3 label'>Role:</span><p className='col-md-9'>{this.props.userProfile.roleName}</p>
                  </div>
                  <div className='user-details'>
                    <span className='col-md-3 label'>Status:</span><p className='col-md-9'>{this.props.userProfile.statusValue}</p>
                  </div>
                </div>
              </div>
              <div className='form-group button-group'>
                <a className='btn btn-primary margin-right-5 btn-siteone-default' onClick={(e) => { this.props.onBack(e); }}><i className='glyphicon glyphicon-menu-left' /> Back</a>
              </div>
            </Col>
          </Row>
        </div>
      </div>;
  }
}




// WEBPACK FOOTER //
// ./src/User/Components/invite-tenant-user.js